import React from 'react'
import { Box, Button, TextField, Typography, Grid } from '@mui/material'
import { useForm } from 'react-hook-form'
import emailjs from 'emailjs-com'
import './contactForm.css'

const ContactForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm()

  const onSubmit = (data) => {
    sendEmail(data)
  }

  const sendEmail = (data) => {
    emailjs
      .send(
        'Kaizen',
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          to_name: 'Charlie',
          from_name: data.Name,
          message: data.Message,
          email: data.Email,
          phone: data.Phone || '',
        },
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then(() => {
        alert('Your message has been recorded. We are on it!')
        reset()
      })
      .catch((error) => {
        alert('Failed to send message.')
        console.error('EmailJS Error:', error)
      })
  }

  return (
    <Box
      width={1}
      sx={{
        py: { xs: 6, md: 8 },
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box className="form-container">
        <Typography
          align="center"
          variant="h4"
          sx={{
            color: '#015f44',
            fontWeight: 700,
            mb: 3,
          }}
        >
          Get in Touch
        </Typography>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={3}>
            {/* LEFT COLUMN */}
            <Grid item xs={12} md={4} container direction="column" spacing={2}>
              <Grid item>
                <TextField
                  fullWidth
                  label="Name"
                  {...register('Name', { required: true })}
                  error={!!errors.Name}
                  helperText={errors.Name ? 'Name is required' : ''}
                  sx={inputStyles}
                />
              </Grid>

              <Grid item>
                <TextField
                  fullWidth
                  label="Email Address"
                  type="email"
                  {...register('Email', { required: true })}
                  error={!!errors.Email}
                  helperText={errors.Email ? 'Email is required' : ''}
                  sx={inputStyles}
                />
              </Grid>

              <Grid item>
                <TextField
                  fullWidth
                  label="Phone Number"
                  type="tel"
                  {...register('Phone')}
                  sx={inputStyles}
                />
              </Grid>
            </Grid>

            {/* RIGHT COLUMN */}
            <Grid item xs={12} md={8}>
              <TextField
                fullWidth
                label="Message / Query"
                multiline
                rows={10}
                {...register('Message', { required: true })}
                error={!!errors.Message}
                helperText={errors.Message ? 'Message is required' : ''}
                sx={inputStyles}
              />
            </Grid>
          </Grid>

          {/* SUBMIT */}
          <Box
            sx={{
              mt: 4,
              display: 'flex',
              justifyContent: { xs: 'center', md: 'flex-end' },
            }}
          >
            <Button
              type="submit"
              sx={{
                backgroundColor: '#015f44',
                color: '#ffffff',
                textTransform: 'none',
                px: 4,
                py: 1,
                fontWeight: 600,
                '&:hover': {
                  backgroundColor: '#8FAA30',
                  color: '#015f44',
                },
              }}
            >
              Submit
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  )
}

/* Shared input styling */
const inputStyles = {
  backgroundColor: '#ffffff',
  borderRadius: '6px',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#015f44',
    },
    '&:hover fieldset': {
      borderColor: '#8FAA30',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#8FAA30',
    },
  },
  '& label': {
    color: '#015f44',
  },
  '& label.Mui-focused': {
    color: '#8FAA30',
  },
}

export default ContactForm
